/** Private and historical properties always resolve in their selected workspace. */
export function propertyDetailPath(id: string, workspaceId: string | null, demo = false): string {
  const property = encodeURIComponent(id);
  return workspaceId
    ? `/workspaces/${encodeURIComponent(workspaceId)}/properties/${property}${demo ? '?demo=true' : ''}`
    : `/properties/${property}${demo ? '?demo=true' : ''}`;
}

export function workspaceScope(userId: string | undefined, workspaceId: string | null): string {
  return `${userId ?? 'anonymous'}:${workspaceId ?? 'none'}`;
}

export function numericInput(value: string): number | null {
  if (!value.trim()) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function conflictMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'status' in error && error.status === 409) {
    return 'This record changed in your workspace. Your edits are still shown. Reload the latest version before saving again.';
  }
  return error instanceof Error ? error.message : 'This could not be saved. Please try again.';
}
